<div class="lum-page lum-page--full-height lum-page__card lum-c-cost-layers">
  <header class="lum-page-header">
    <h2 class="lum-page-header__heading">Cost Layers</h2>
    <div class="lum-page-header__actions">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        [disabled]="!basicTableGridApi"
        (click)="handleExportButtonClick($event)"
      >
        <i class="fas fa-download"></i>
        Export
      </button>
    </div>
  </header>

  <div class="lum-page-content lum-page__ag-grid">
    <lum-cost-layers-basic-table
      class="lum-page__ag-grid__table"
      (gridReady)="handleGridReady($event)"
      (loadError)="handleLoadError($event)"
      (loadStart)="handleLoadStart()"
      (loadSuccess)="handleLoadSuccess($event)"
    ></lum-cost-layers-basic-table>
  </div>

  <div
    class="overlay"
    lumAppLoader
    [loading]="store.costLayersLoading$ | async"
    [classes]="'loading blur'"
  ></div>
</div>
